export default [
  { id: 1, 작업내용: '금속공사',
    유해위험요인: '절단, 가공작업 시 보안경 미착용 결과 절삭물 \n' +
      '비산으로 인한 안구 손상',
    개선대책: '1. 절단, 가공 작업 시 보안경 등 보호구 착용',
  },
  { id: 2, 작업내용: '금속공사',
    유해위험요인: '교류 아크용접기에 자동 전격방지기 미설치로 인한 감전',
    개선대책: '1. 교류 아크용접기를 사용하여 용접작업 시 자동 \n    전격방지기 설치',
  },
  { id: 3, 작업내용: '금속공사',
    유해위험요인: '인화물질 등의 위험물 주변에서 화기를 사용하다가 화재 발생',
    개선대책: '1. 인화물질 주변에서 화기 사용금지위험물 별도 보관',
  },
  { id: 4, 작업내용: '금속공사',
    유해위험요인: '철물 절단용 고속 절단기 회전부의 덮개 미설치로 인해 신체 상해',
    개선대책: '1. 적정중량을 준수하여 운반\n' +
      '2. 긴 부재 등은 가능한 한 2인 1조',
  },
  { id: 5, 작업내용: '금속공사',
    유해위험요인: '자재 운반 시 지게차에 의한 근로자 충돌, 끼임',
    개선대책: '1. 지게차 운행 시 유도자 배치 등을 통해 통행 지도',
  },
  { id: 6, 작업내용: '금속공사',
    유해위험요인: '길이가 긴 자재를 인력운반 중 주변 고압선에 \n' +
      '접촉되어 감전',
    개선대책: '1. 자재 운반 시 사전에 주변 고압선을 파악하여 \n    운반방법 선정',
  },
  { id: 7, 작업내용: '금속공사',
    유해위험요인: '자재 운반대차에 철물자재를 싣고 인력 운반 중 \n' +
      '자재 쓰러짐',
    개선대책: '1. 자재운반을 위한 적재 시 수평유지와 쓰러짐방지를 위해 결속',
  },
  { id: 8, 작업내용: '금속공사',
    유해위험요인: '건물 발코니 등 외부에서 인력으로 무리하게 자재를 인양, 하역하다가 자재 낙하',
    개선대책: '1. 자재 인양 시 인양기계, 기구 사용',
  },
  { id: 9, 작업내용: '금속공사',
    유해위험요인: '리프트 출입문을 개방하고 철물자재를 인양 중 \n' +
      '자재와 함께 지상으로 추락',
    개선대책: '1. 리프트에 철물자재 적재 시 리프트 크기에 적합한 \n    자재를 선정하고 출입문 개방상태에서 운행 금지',
  },
  { id: 10, 작업내용: '금속공사',
    유해위험요인: '이동식 비계에 안전난간 미설치로 인해 작업발판 \n' +
      '단부로 추락',
    개선대책: '1. 상부 안전난간대 설치\n' +
      '2. 작업발판 고정,\n' +
      '3. 바퀴 제동 장치 사용',
  },
  { id: 11, 작업내용: '금속공사',
    유해위험요인: '연삭기, 용접기 사용 중 불티가 주변 인화물질에 \n' +
      '옮겨붙어 화재 발생',
    개선대책: '1. 연삭기, 용접기 사용 시 불꽃 비산 방지시설 설치 및 \n    소화기 비치 확인',
  },
  { id: 12, 작업내용: '금속공사',
    유해위험요인: '외함이 일부 파손된 핸드그라인더 사용 중 누전에 의한 감전',
    개선대책: '1. 핸드그라인더 사용 전 점검, 파손 및 누전 여부 확인 후 \n    작업 실시',
  },
  { id: 13, 작업내용: '금속공사',
    유해위험요인: '목재로 제작된 말비계 사용 중 작업발판 붕괴로 \n' +
      '근로자 추락',
    개선대책: '1. 견고하고 규정에 적합하게 말비계를 제작하거나\n    알루미늄 재료 등으로 제작된 제품 사용',
  },
]
